/**
 * Контент довідки для сторінки сповіщень (Notifications).
 * Використовується в панелі довідки HelpPanel.
 */
export default {
  pageKey: 'notifications',
  titleKey: 'help.pages.notifications.title',
  overviewKey: 'help.pages.notifications.overview',
  tourId: 'notifications-page',

  faq: [
    {
      id: 'notification-channels',
      questionKey: 'help.pages.notifications.faq.channels.question',
      answerKey: 'help.pages.notifications.faq.channels.answer',
    },
    {
      id: 'telegram-connect',
      questionKey: 'help.pages.notifications.faq.telegram.question',
      answerKey: 'help.pages.notifications.faq.telegram.answer',
    },
    {
      id: 'notification-types',
      questionKey: 'help.pages.notifications.faq.types.question',
      answerKey: 'help.pages.notifications.faq.types.answer',
    },
    {
      id: 'notification-language',
      questionKey: 'help.pages.notifications.faq.language.question',
      answerKey: 'help.pages.notifications.faq.language.answer',
    },
    {
      id: 'disable-notifications',
      questionKey: 'help.pages.notifications.faq.disable.question',
      answerKey: 'help.pages.notifications.faq.disable.answer',
    },
  ],

  tooltips: {
    tabs: 'help.tooltips.notifications.tabs',
    toggle: 'help.tooltips.notifications.toggle',
    preferences: 'help.tooltips.notifications.preferences',
  },

  relatedTours: ['devices-page', 'maintenance-page'],
}
